/* ============================================================
   BIO PERFORMANCE LABS — THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── STICKY HEADER: hide pill at top (homepage only), show on scroll, hide on scroll down ──
  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var lastY = 0;
    var scrollUpAccum = 0;
    var scheduled = false;
    var isHomepage = document.body.classList.contains('template-index');
    var HIDE_DELTA = 8;
    var SHOW_DELTA = 30;

    // Start with is-top if at top of homepage
    if (isHomepage && (window.pageYOffset || document.documentElement.scrollTop) < 50) {
      header.classList.add('is-top');
    }

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y < 0) y = 0;
      var delta = y - lastY;

      if (isHomepage && y < 50) {
        header.classList.add('is-top');
        header.classList.remove('is-scrolled');
      } else {
        header.classList.remove('is-top');
        if (y > 50) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }

      if (delta > 0) {
        // Scrolling down — reset scroll-up accumulator
        scrollUpAccum = 0;
        var dropdownOpen = document.querySelector('.mega-dropdown.is-open');
        if (delta > HIDE_DELTA && y > 80 && !dropdownOpen) {
          header.classList.add('is-hidden');
        }
      } else if (delta < 0) {
        // Scrolling up — accumulate distance
        scrollUpAccum += Math.abs(delta);
        if (scrollUpAccum > SHOW_DELTA || y < 50) {
          header.classList.remove('is-hidden');
        }
      }

      lastY = y;
      scheduled = false;
    }

    window.addEventListener('scroll', function() {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
  })();



  // ── PAGE FADE IN ──
  document.body.classList.add('page-fade-in');

  // ── MOBILE MENU ──
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');
  const siteHeader = document.querySelector('[data-header]');

  function openMobileMenu() {
    if (!mobileNav || !mobileToggle) return;
    // Set stagger index on each direct child for cascading reveal
    Array.from(mobileNav.children).forEach(function(child, i) {
      child.style.setProperty('--i', i);
    });
    mobileNav.classList.add('is-open');
    mobileToggle.classList.add('is-active');
    mobileToggle.setAttribute('aria-expanded', 'true');
    if (siteHeader) siteHeader.classList.add('menu-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileNav || !mobileToggle) return;
    mobileNav.classList.remove('is-open');
    mobileToggle.classList.remove('is-active');
    mobileToggle.setAttribute('aria-expanded', 'false');
    if (siteHeader) siteHeader.classList.remove('menu-open');
    document.body.style.overflow = '';
  }

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      if (mobileNav.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMobileMenu();
      }
    });

    // Close when clicking a nav link
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMobileMenu();
      });
    });

    // Close button inside overlay
    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        closeMobileMenu();
      });
    }

    // Accordion toggles (Peptides dropdown)
    mobileNav.querySelectorAll('[data-mobile-accordion]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var accordion = btn.closest('.mobile-nav__accordion');
        if (accordion) accordion.classList.toggle('is-expanded');
      });
    });
  }

  // ── QUANTITY SELECTOR ──
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-selector__input');
    const minus = selector.querySelector('[data-qty="minus"]');
    const plus = selector.querySelector('[data-qty="plus"]');

    if (!input) return;

    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        input.value = val + 1;
      });
    }
  });

  // ── ADD TO CART ──
  const addToCartForms = document.querySelectorAll('.product-add-to-cart-form');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('.qty-selector__input')?.value || 1;

      if (!variantId) return;

      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding\u2026';
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });

        if (response.ok) {
          showCartNotification();
          updateCartCount();
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:6px"><polyline points="20 6 9 17 4 12"></polyline></svg>Item added to cart';
          setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
          return;
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      }
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    });
  });

  // ── CART NOTIFICATION ──
  function showCartNotification() {
    const notification = document.getElementById('cart-notification');
    if (!notification) return;
    notification.classList.add('is-visible');
    setTimeout(() => notification.classList.remove('is-visible'), 3500);
  }

  const notifClose = document.querySelector('.cart-notification__close');
  if (notifClose) {
    notifClose.addEventListener('click', () => {
      document.getElementById('cart-notification')?.classList.remove('is-visible');
    });
  }

  // ── CART COUNT ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    } catch (e) {}
  }

  updateCartCount();

  // ── MEGA DROPDOWN PORTAL ──
  // Moves dropdowns out of the pill element so backdrop-filter isn't trapped
  // by the pill's own stacking context
  (function() {
    var triggers = document.querySelectorAll('.nav-dropdown-trigger');
    if (!triggers.length) return;

    var activeDropdown = null;
    var hideTimer = null;

    triggers.forEach(function(trigger) {
      var dropdown = trigger.querySelector('.mega-dropdown');
      if (!dropdown) return;

      // Escape the pill's stacking context
      document.body.appendChild(dropdown);

      function position() {
        var rect = trigger.getBoundingClientRect();
        var w = dropdown.offsetWidth || 920;
        var top = rect.bottom + 12;
        var left = rect.left + rect.width / 2 - w / 2;
        left = Math.max(16, Math.min(left, window.innerWidth - w - 16));
        dropdown.style.top = top + 'px';
        dropdown.style.left = left + 'px';
      }

      function show() {
        clearTimeout(hideTimer);
        if (activeDropdown && activeDropdown !== dropdown) {
          activeDropdown.classList.remove('is-open');
        }
        activeDropdown = dropdown;
        position();
        dropdown.classList.add('is-open');
      }

      function scheduleHide() {
        hideTimer = setTimeout(function() {
          dropdown.classList.remove('is-open');
          if (activeDropdown === dropdown) activeDropdown = null;
        }, 120);
      }

      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('mouseleave', scheduleHide);
      dropdown.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
      dropdown.addEventListener('mouseleave', scheduleHide);
    });

    window.addEventListener('resize', function() {
      if (activeDropdown && activeDropdown.classList.contains('is-open')) {
        var trigger = document.querySelector('.nav-dropdown-trigger:hover');
        if (trigger) {
          var rect = trigger.getBoundingClientRect();
          var w = activeDropdown.offsetWidth || 920;
          var left = rect.left + rect.width / 2 - w / 2;
          left = Math.max(16, Math.min(left, window.innerWidth - w - 16));
          activeDropdown.style.top = (rect.bottom + 12) + 'px';
          activeDropdown.style.left = left + 'px';
        }
      }
    });
  })();

  // ── COLLECTION FILTER TABS ──
  document.querySelectorAll('.filter-tab').forEach(tab => {
    tab.addEventListener('click', function () {
      const tag = this.dataset.tag;

      document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const cards = document.querySelectorAll('.product-card-wrapper');
      let visibleCount = 0;

      cards.forEach(card => {
        if (!tag || tag === 'all') {
          card.style.display = '';
          visibleCount++;
        } else {
          const cardTags = card.dataset.tags || '';
          if (cardTags.toLowerCase().includes(tag.toLowerCase())) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        }
      });

      const countEl = document.querySelector('.collection-filters__count');
      if (countEl) countEl.textContent = visibleCount + ' Products';
    });
  });

  // ── CONTACT FORM ──
  const contactForm = document.querySelector('.brl-contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = contactForm.querySelector('[type="submit"]');
      btn.innerHTML = 'Sending...';
      btn.disabled = true;

      // Shopify contact form submits to /contact
      const formData = new FormData(contactForm);

      try {
        await fetch('/contact', {
          method: 'POST',
          body: formData
        });
        contactForm.innerHTML = '<div style="padding:40px;text-align:center;"><p style="font-family:var(--font-mono);font-size:12px;letter-spacing:0.3em;color:var(--color-steel);text-transform:uppercase;">Message Sent — We\'ll be in touch shortly.</p></div>';
      } catch (e) {
        btn.innerHTML = 'Send Message →';
        btn.disabled = false;
      }
    });
  }

});
